<template>
  <div>
    <v-container :style="initialHeight">
      <v-row v-if="filename">
        <v-col xs="12" sm="12" md="12">
          <div class="movie-wrap" id="player">
          </div>
        </v-col>
      </v-row>
      <v-row v-else>
        <p>動画の取得に失敗しました。再度お試しください。</p>
      </v-row>
    </v-container>
    <div v-if="isFromNewSite" class="topback">
      <NewReturnButton :text="'まなびチャンネルにもどる'" @click="returnToNewContents" />
    </div>
    <return-button v-else :to="'/contents'" />
  </div>
</template>

<script>
import axios from 'axios'
import ReturnButton from '../atoms/ReturnButton.vue'
import NewReturnButton from '../atoms/NewReturnButton.vue'
import '@/assets/css/stylesheets/oneTagPlayer.css'
import jQuery from 'jquery'
global.jquery = jQuery
global.$ = jQuery

export default {
  components: {
    ReturnButton,
    NewReturnButton
  },
  head () {
    return {
      script: [
        { type: 'text/javascript', src: '/js/oneTagPlayer.js', async: true }
      ],
    }
  },
  data () {
    return {
      movie: {},
    }
  },
  computed: {
    filename() {
      return this.$store.state.movieFilename
    },
    initialHeight() {
      return `height: ${(this.$root.$el.clientWidth * 9 / 16) + 300}px`
    },
    isFromNewSite() {
      return this.$store.state.prevPath?.startsWith('/new/contents') ?? false
    }
  },
  beforeMount () {
    if (this.filename) this.loadDatas()
  },
  mounted() {
    if (this.isFromNewSite) {
      document.body.style.backgroundImage = 'none'
      document.body.style.backgroundColor = '#ffffff'
    }
  },
  beforeDestroy() {
    this.$store.commit('SET_MOVIE_FILE_NAME', { filename: '' })
    if (this.isFromNewSite) {
      document.body.style.backgroundImage = ''
      document.body.style.backgroundColor = ''
    }
  },
  watch: {
    async movie () {
      await window.CreateVideoPlayer({target: 'player', src: this.movie.url, auto: 'off', movieid: this.movie.name})
      this.adjustSize()
    }
  },
  methods: {
    async loadDatas () {
      const res = await axios.get(`api/v1/movies/${this.filename}`)
      this.movie = res.data.movie
    },
    adjustSize() {
      const wrap = global.$('.cp-videoplayer');
      wrap.css('height',(wrap.width() * 9 / 16) + 200);
    },
    returnToNewContents() {
      this.$router.push(this.$store.state.prevPath)
    }
  }
}
</script>

<style lang="scss" scoped>
.show-content {
  max-width: 800px;
  margin:auto;
}
input {
  background-image: unset !important;
}
.topback {
  text-align: center;
}
</style>
